import { render, staticRenderFns } from "./AccountEvents.vue?vue&type=template&id=3520d726"
import script from "./AccountEvents.vue?vue&type=script&lang=ts"
export * from "./AccountEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports